export const addressFields = [
  {
    id: 'addressLine1',
    name: 'Street Address',
    required: true,
    type: 'text',
  },
  {
    id: 'addressLine2',
    name: 'Street Address Line 2',
    required: false,
    type: 'text',
  },
  {
    id: 'city',
    name: 'City',
    required: true,
    type: 'text',
  },
  {
    id: 'state',
    name: 'State / Province',
    required: true,
    type: 'text',
  },
  {
    id: 'zip',
    name: 'Postal / Zip Code',
    required: true,
    type: 'text',
  },
  {
    id: 'country',
    required: true,
    type: 'text',
    name: 'Country',
  },
]
